import { render, staticRenderFns } from "./SendOnePlatformDetail.vue?vue&type=template&id=48b99964&scoped=true&"
import script from "./SendOnePlatformDetail.vue?vue&type=script&lang=js&"
export * from "./SendOnePlatformDetail.vue?vue&type=script&lang=js&"
import style0 from "./SendOnePlatformDetail.vue?vue&type=style&index=0&id=48b99964&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b99964",
  null
  
)

export default component.exports